import { css } from 'styled-components';
import { newColors } from 'themes/variables';
import { mediaq } from '~/themes/style-utils-v2';
const getBackground = ({ backgroundColor, textColor, clear, invert }) => {
    if (clear)
        return 'transparent';
    if (invert)
        return textColor || newColors.snow;
    if (backgroundColor)
        return backgroundColor;
    return newColors.purple500;
};
const getTextColor = ({ backgroundColor, textColor, clear, invert }) => {
    if (clear)
        return textColor;
    if (invert)
        return backgroundColor || newColors.purple500;
    if (textColor)
        return textColor;
    return newColors.snow;
};
const getBorder = ({ backgroundColor, borderColor, clear, invert }) => {
    let defaultColor = 'none';
    if (invert && borderColor !== 'none') {
        defaultColor = backgroundColor || newColors.purple500;
    }
    else if (borderColor) {
        defaultColor = borderColor;
    }
    return defaultColor === 'none' ? defaultColor : `1px solid ${defaultColor}`;
};
const styles = css `
  background: ${(props) => getBackground(props)};
  color: ${(props) => getTextColor(props)};
  white-space: nowrap;
  border-radius: ${(props) => (props.borderRadius ? props.borderRadius : '30')}px;
  width: ${(props) => props.width || '100%'};
  min-width: ${(props) => props.minWidth || 'initial'};
  max-width: ${(props) => props.maxWidth || 'initial'};
  height: ${(props) => props.height || '100%'};
  min-height: ${(props) => props.minHeight || 'initial'};
  max-height: ${(props) => props.maxHeight || 'initial'};
  padding: 10px 16px;
  font-family: 'Inter Variable', sans-serif;
  font-size: ${(props) => props.fontSize || 14}px;
  font-weight: ${(props) => props.fontWeight || '600'};
  line-height: 24px;
  cursor: pointer;
  border: ${(props) => getBorder(props)};
  opacity: 1;
  transition: opacity ease 300ms;
  ${mediaq.md `
  font-size: 14px;
  line-height: 22px;
  `}

  &:hover,
  &:active {
    background-color: ${(props) => props.hoverBackgroundColor || newColors.gray500};
  }

  &:disabled {
    background: ${(props) => props.disabledBackgroundColor || newColors.gray100};
    color: ${newColors.gray500};
    cursor: not-allowed;
  }

  .icon.left {
    margin-right: 8px;
  }

  .icon.right {
    margin-left: 8px;
  }
`;
export default styles;
